module.exports = __webpack_public_path__ + "img/Avatar-24.3e7c2684.gif";